export default function EmailService() {
  return <div>Email Service Page</div>;
}
